import gql from 'graphql-tag';

export default gql`
  query ward2507Search($provinceCodes: [String], $pagination: Pagination!, $wardCodes: [String], $orderBy: [OrderBy]) {
    ward2507Search(provinceCodes: $provinceCodes, pagination: $pagination, wardCodes: $wardCodes, orderBy: $orderBy) {
      total
      data {
        code
        name
        nameEn
        fullName
        fullNameEn
        provinceCode
      }
    }
  }
`;
